var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{ref:"cascader",attrs:{"props":_vm.props,"clearable":"","size":"small"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }